import ProfileIcon from '../assets/icons/profile.svg';
import EnvelopeIcon from '../assets/icons/envelope.svg';
import VerifyIcon from '../assets/icons/verify.svg';
import SettingIcon from '../assets/icons/settings (5) 1.svg';

const BASE_MOBILE_STEPS = [
  { id: 1, name: 'Account', icon: ProfileIcon, alt: 'Create Account' },
  { id: 2, name: 'Verify Email', icon: EnvelopeIcon, alt: 'Verify Email' },
  { id: 3, name: 'Register Test', icon: VerifyIcon, alt: 'Register Blood Test' },
  { id: 4, name: 'Profile', icon: SettingIcon, alt: 'Complete Profile' },
];

const MOBILE_STEPS_WITH_PASSWORD = [
  { id: 1, name: 'Account', icon: ProfileIcon, alt: 'Create Account' },
  { id: 2, name: 'Verify Email', icon: EnvelopeIcon, alt: 'Verify Email' },
  { id: 3, name: 'Password', icon: SettingIcon, alt: 'Set New Password' },
  { id: 4, name: 'Register Test', icon: VerifyIcon, alt: 'Register Blood Test' },
  { id: 5, name: 'Profile', icon: SettingIcon, alt: 'Complete Profile' },
];

export default function MobileStepStatus({ activeStep = 1, showPasswordStep = false }) {
  const MOBILE_STEPS = showPasswordStep
    ? MOBILE_STEPS_WITH_PASSWORD
    : BASE_MOBILE_STEPS;
  const totalSteps = MOBILE_STEPS.length;
  const safeStep = Math.min(Math.max(activeStep, 1), totalSteps);
  const completedRatio =
    totalSteps > 1 ? (safeStep - 1) / (totalSteps - 1) : 0;
  const edgePaddingPercent = 50 / totalSteps;
  const trackWidthPercent = 100 - edgePaddingPercent * 2;

  return (
    <div className="lg:hidden w-full mb-4 p-3">
      <div className="relative">
        <div
          className="absolute top-[18px] h-[2px] bg-[#D9D9D9]"
          style={{ left: `${edgePaddingPercent}%`, right: `${edgePaddingPercent}%` }}
        />
        <div
          className="absolute top-[18px] h-[2px] bg-[#119975] transition-all duration-300"
          style={{
            left: `${edgePaddingPercent}%`,
            width: `${completedRatio * trackWidthPercent}%`,
          }}
        />
        <div
          className="relative gap-2"
          style={{ display: 'grid', gridTemplateColumns: `repeat(${totalSteps}, minmax(0, 1fr))` }}
        >
        {MOBILE_STEPS.map((step) => {
          const isActive = step.id === safeStep;
          const isCompleted = step.id < safeStep;
          const isInactive = step.id > safeStep;

          return (
            <div key={step.id} className="flex flex-col items-center text-center gap-1">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center ${
                  isCompleted
                    ? 'bg-[#119975]'
                    : isActive
                    ? 'border-2 border-[#119975] bg-white'
                    : 'bg-[#E5E5E5]'
                }`}
              >
                {isCompleted ? (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <>
                    {isActive ? (
                      <span
                        aria-label={step.alt}
                        className="w-4 h-4 block"
                        style={{
                          backgroundColor: '#119975',
                          WebkitMaskImage: `url("${encodeURI(step.icon)}")`,
                          maskImage: `url("${encodeURI(step.icon)}")`,
                          WebkitMaskRepeat: 'no-repeat',
                          maskRepeat: 'no-repeat',
                          WebkitMaskPosition: 'center',
                          maskPosition: 'center',
                          WebkitMaskSize: 'contain',
                          maskSize: 'contain',
                        }}
                      />
                    ) : (
                      <img
                        src={step.icon}
                        alt={step.alt}
                        className={`w-5 h-5 object-contain ${isInactive ? 'opacity-60' : ''}`}
                      />
                    )}
                  </>
                )}
              </div>
              <span className={`text-[10px] leading-tight font-poppins ${isInactive ? 'text-[#889696]' : 'text-[#2B3133]'}`}>
                {step.name}
              </span>
            </div>
          );
        })}
        </div>
      </div>
    </div>
  );
}

